/**
 * ----------------------------------------------------------------------------------------------
 * individual JS for Product Page
 * ----------------------------------------------------------------------------------------------
 */

// const calcProductDescriptionCollapsible = ()=>{
//   const product_description = document.querySelector('#Collapsible-Product-Description .Collapsible__Content');
//   if(product_description && product_description.clientHeight > 620){
//     document.querySelector('#Collapsible-Product-Description').classList.remove("is-non-collapsible");
//   }else{
//     document.querySelector('#Collapsible-Product-Description').classList.add("is-non-collapsible");
//   }
// }

// window.addEventListener('DOMContentLoaded', () => {
//   calcProductDescriptionCollapsible()

//   window.addEventListener('resize',calcProductDescriptionCollapsible);
// });

// // 商品説明のTopへ戻る
// const scrollProductDescription = (e)=>{
//   e.preventDefault();
//   const header_height = document.getElementById('shopify-section-header').clientHeight;
//   const product_description = document.querySelector('#Collapsible-Product-Description .Collapsible__Content');
//   const rect = product_description.getBoundingClientRect().top;
//   const offset = window.pageYOffset;
//   const gap = header_height+15;
//   const target = rect + offset - gap;
//   window.scrollTo({
//     top: target,
//     behavior: 'smooth',
//   });
// }

// 再入荷通知アプリ呼び出し
//
// アプリ(.BIS_trigger)は対象SKUを、商品フォームの [name="id"] の値から読む。
// バリエーションを切り替えてから押したときに古いSKUが渡らないよう、
// クリック直前に選択中バリエーションを select へ反映し change を発火させる。
const syncVariantSelectBeforeBIS = () => {
  const form = document.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  const variantSelect = form.querySelector('select[name="id"]');
  if (!variantSelect) return;

  const selectedOption = variantSelect.querySelector('[selected]');
  if (!selectedOption) return;

  if (variantSelect.value === selectedOption.value) return;

  variantSelect.value = selectedOption.value;
  variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
};

const callBackInStock = (e) => {
  e.preventDefault();
  syncVariantSelectBeforeBIS();

  const backInStockBtn = document.querySelector(".BIS_trigger");
  if (backInStockBtn) {
    backInStockBtn.click();
  }
};

// 2023.10.27 Add 特定バリエーションのカラーオプション・カートを非表示
document.addEventListener("variant:changed", function (event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  var productId = document.querySelector(`input[name="product-id"]`);

  if (productId && productId.value === "7892150845627") {
    const hiddenOptionLL = document.querySelector(
        '[data-option-position="2"][value="LL"]'
      ),
      hiddenOptionKhaki = document.querySelector(
        '[data-option-position="1"][value="カーキ"]'
      );

    // "カーキ"選択時、LLを非表示
    if (variant.options.indexOf("カーキ") > -1 && hiddenOptionLL) {
      hiddenOptionLL.parentNode.setAttribute("hidden", true);
    } else if (variant.options.indexOf("カーキ") === -1 && hiddenOptionLL) {
      hiddenOptionLL.parentNode.removeAttribute("hidden");
    }

    // "LL"選択時、LLを非表示
    if (variant.options.indexOf("LL") > -1 && hiddenOptionKhaki) {
      hiddenOptionKhaki.parentNode.setAttribute("hidden", true);
    } else if (variant.options.indexOf("LL") === -1 && hiddenOptionKhaki) {
      hiddenOptionKhaki.parentNode.removeAttribute("hidden");
    }
  }
});
// 2023.10.27 end 特定バリエーションのカラーオプション・カートを非表示

// 2024.7.29 Add バリエーション変更処理([select-art]テンプレート) 
// _optionPosition : 指定オプションの位置(0〜2)
// _optionIndex : 指定オプションのインデックス
const changeVariant = (_optionPosition,_optionIndex) => {
  const targetRadioBtn = document.querySelector(`input[name="option-${_optionPosition}"][data-option-index="${_optionIndex}"]`);
  if(targetRadioBtn) {
    targetRadioBtn.click();

    // カートに追加ボタンの切り替え
    const currentAddToCartBtn = document.querySelector(`.c-popup-button`);

    // 選択中アート画像・ボタンの切り替え
    const selectedArtElems = document.querySelectorAll(`[data-art-option-target].is-selected`);
    if(selectedArtElems.length > 0){
      selectedArtElems.forEach((selectedArtElem)=>{
        selectedArtElem.classList.remove("is-selected");
      });
    }

    const updatedArtElems = document.querySelectorAll(`[data-art-option-target="${_optionIndex}"]`);
    if(updatedArtElems.length > 0){
      updatedArtElems.forEach((updatedArtElem)=>{
        updatedArtElem.classList.add("is-selected");
      });
    }
  }
}
// 2024.7.29 End バリエーション変更処理([select-art]テンプレート) 

// 2024.08.01 Add listing_parent用 ページ遷移処理
document.addEventListener('DOMContentLoaded', () => {
  const listingParentSelect = document.querySelector('select[id^="ListingParentSelect-"]');
  if (listingParentSelect) {
    listingParentSelect.addEventListener('change', (event) => {
      const selectedUrl = event.target.value;
      if (selectedUrl) {
        window.location.href = selectedUrl;
      }
    });
  }
});
// 2024.08.01 End listing_parent用 ページ遷移処理 



/*
  【Other Art Display】
  JavaScript implementation of c-other-art functionality
*/
const renderOtherArt = async () => {
  // 商品ページでない場合は処理しない
  if (typeof window.meta === 'undefined' || !window.meta.product) {
    return;
  }

  const currentProduct = window.meta.product;
  const otherArtContainerList = document.querySelectorAll('.js-other-art-container');
  
  if (!otherArtContainerList || otherArtContainerList.length === 0) {
    return;
  }

  try {
    // 全商品データを取得
    const allProducts = await fetchAllProducts();
    
    // 現在の商品のSKUIDを取得
    const baseProductSkuid = extractSkuId(currentProduct.variants[0].sku);

    console.log("baseProductSkuid",baseProductSkuid);
    
    if (!baseProductSkuid || baseProductSkuid.length === 0) {
      return;
    }

    // OTHER ART商品をフィルタリング
    const otherArtProducts = filterOtherArtProducts(allProducts, currentProduct, baseProductSkuid);
    
    console.log("otherArtProducts",otherArtProducts);
    if (otherArtProducts.length >= 1) {
      // OTHER ARTセクションをレンダリング
      renderOtherArtSection(otherArtContainerList, otherArtProducts);
    }
  } catch (error) {
    console.error('Error rendering other art:', error);
  }
}

// SKUからIDを抽出する関数 HLまたはHBに変更
// SKUの形: HL-<品番>-<アイテムコード>-<アート番号>[-<サイズ記号>]
// OTHER ART は「アイテムコードが同じ＝同じ商品でアートだけ違う」商品を集めるので、
// ここではアイテムコードを返す。
//
// 品番は旧体系が4桁（すべて 0000 ＝未設定）、新体系が5桁（例: 26209 / 26210）。
// 新体系はアイテムコードの採番を1から振り直しているため、旧体系とコードが衝突する。
//   CS13: 旧=レギュラーフィットクループルオーバー / 新=Art Print Crewneck Sweatshirt
//   FG16: 旧=COTODAMAキャップ / 新=【HEART】Carabiner
// 一方、新体系の中では品番をまたいで同じアイテムが続く（BL1 は 26209-BL1-1〜3 と
// 26210-BL1-4,5 で同じサテンボウタイブラウス）。
// そのため品番そのものではなく、採番体系の世代（旧=4桁 / 新=5桁以上）で名前空間を分ける。
const extractSkuId = (sku) => {
  if (!sku) return '';
  const skuSplit = sku.split('-');
  const brand = skuSplit[0];
  const serial = skuSplit[1];

  if (brand !== 'HL' && brand !== 'HB') return '';
  if (!serial || !skuSplit[2]) return '';

  let generation = '';
  if (serial.length === 4) {
    generation = 'legacy';
  } else if (/^\d{5,}$/.test(serial)) {
    generation = 'current';
  } else {
    return '';
  }

  let itemCode = skuSplit[2];
  // 旧体系に HL-0000-C-O02-1 のような「C + アイテムコード」の形がある。
  // 続くセグメントが数字だけのときはアート番号なので繋がない。
  if (itemCode === 'C' && skuSplit[3] && !/^\d+$/.test(skuSplit[3])) {
    itemCode += skuSplit[3];
  }

  return generation + ':' + itemCode;
};

// リスティング商品かどうかをチェック
const isListingProduct = (product) => {
  if (product.tags && product.tags.includes('listing_parent')) {
    return false;
  }
  
  // 商品オプションにproduct_urlがあるかチェック（簡易版）
  return false; // APIから取得できる情報では判定が困難なため、一旦false
}

// OTHER ART商品をフィルタリング
const filterOtherArtProducts = (allProducts, currentProduct, baseProductSkuid) => {
  return allProducts.filter(product => {
    // 同じ商品IDは除外
    if (product.id === currentProduct.id) {
      return false;
    }
    
    // リスティング商品は除外
    if (isListingProduct(product)) {
      return false;
    }

    // SEO非表示の商品は除外
    if (Number(product.metafields?.seo?.hidden) === 1) {
      return false;
    }
    
    // SKUIDが一致する商品のみ
    const productSkuid = extractSkuId(product.variants[0].sku);
    return baseProductSkuid === productSkuid && productSkuid.length > 0;
  });
}

// OTHER ARTセクションをレンダリング
const renderOtherArtSection = (containerList, products) => {
  const html = `
    <div class="c-ProductOtherArt">
      <h3 class="c-ProductOtherArt__title">OTHER ART</h3>
      <div class="c-ProductOtherArt__ItemList">
        ${products.map(product => `
          <a href="/products/${product.handle}" class="c-ProductOtherArt__Item">
            <img src="${product.image || ''}" 
                 alt="${product.title}" 
                 loading="lazy" 
                 class="c-ProductOtherArt__ItemImage">
            <span class="c-ProductOtherArt__ItemName">${getArtworkName(product)}</span>
          </a>
        `).join('')}
      </div>
    </div>
  `;
  
  containerList.forEach(container => {
    container.innerHTML = html;
  });
}

// アートワーク名
// - product.titleに「」で囲まれた文字が含まれる場合、「」より前のテキストをタイトルとして表示する
const getArtworkName = (product) => {
  const productTitle = product.title;
  if(productTitle.includes("「") && productTitle.includes("」")){
    const productTitleSplit = productTitle.split("「")[1].split("」")[0];
    return productTitleSplit;
  }
  return productTitle;
}

/*
  【Artist Item Display】
  JavaScript implementation of c-artist-item-block functionality
*/
const renderArtistItem = async () => {
  const artistItemContainerList = document.querySelectorAll('.js-artist-item-container');
  
  if (!artistItemContainerList || artistItemContainerList.length === 0) {
    return;
  }

  try {
    // 全商品データを取得
    const allProducts = await fetchAllProducts();

    artistItemContainerList.forEach(async (container) => {
      const baseArtwork = container.dataset.baseArtwork;
      const currentProductId = parseInt(container.dataset.currentProductId);

      if (!baseArtwork || baseArtwork.trim() === '') {
        return;
      }

      // 同じアートワークの商品をフィルタリング
      const artistItemProducts = allProducts
        .filter(product => 
          product.metafields.artwork && product.metafields.artwork["name"] === baseArtwork
          && product.id !== currentProductId
          && !isListingProduct(product)
          && Number(product.metafields?.seo?.hidden) !== 1
        )
        .sort((a, b) => new Date(b.published_at || 0) - new Date(a.published_at || 0));

      if (artistItemProducts.length > 0) {
        // Artist Itemセクションをレンダリング
        renderArtistItemSection(container, artistItemProducts);
      }
    });

  } catch (error) {
    console.error('Error rendering artist item:', error);
  }
}

// Artist Itemセクションをレンダリング
const renderArtistItemSection = (container, products) => {
  // 価格をフォーマット
  const formatPrice = (price) => {
    if (!price) return '';
    const priceNumber = parseFloat(price) / 100;
    return `¥${priceNumber.toLocaleString()}`;
  }

  // お気に入り済み variant ID Set（product-item.liquid と同じ判定ロジック）
  const wishlistVariantIdSet = new Set(
    (window.multilikesConfig?.wishlistVariantIds || []).map(id => String(id))
  );

  const carouselItems = products.map(product => {

    // 商品タイトル整形（「」で囲まれた部分を除去）
    let productTitle = product.title;
    if (productTitle.includes('「') && productTitle.includes('」')) {
      const titleBeforeQuote = productTitle.split('「')[0];
      if (titleBeforeQuote.trim() !== '') {
        productTitle = titleBeforeQuote.trim();
      }
    }
    

    // 価格表示
    const variant = product.variants[0];
    let priceHtml = '';
    // OUTLET タグの商品は「定価(取り消し線) 販売価格」の順(product-item.liquid と同じ形。#141)
    // 組にするのは、定価のあるバリエーションのうち最安のもの(product-item.liquid と同じ選び方)
    const isOutlet = (product.tags || []).includes('OUTLET');
    const outletVariant = isOutlet
      ? [...(product.variants || [])].sort((a, b) => a.price - b.price).find(v => v.compare_at_price && v.compare_at_price > v.price)
      : null;
    let priceListClass = '';
    if (variant) {
      if (outletVariant) {
        priceListClass = ' c-SalePriceType--outlet';
        priceHtml = `
          <span class="ProductItem__Price Price Price--compareAt c-OutletPrice__Compare t-price-compare">${formatPrice(outletVariant.compare_at_price)}</span>
          <span class="ProductItem__Price Price Price--highlight t-price">${formatPrice(outletVariant.price)}</span>
        `;
      } else if (product.compare_at_price && product.compare_at_price > product.price) {
        priceHtml = `
          <span class="ProductItem__Price Price Price--highlight Text--subdued">${formatPrice(variant.price)}</span>
          <span class="ProductItem__Price Price Price--compareAt Text--subdued">${formatPrice(product.compare_at_price)}</span>
        `;
      } else {
        priceHtml = `<span class="ProductItem__Price Price Text--subdued">${formatPrice(variant.price)}</span>`;
      }
    }
    
    // ラベル表示
    // 販売開始日時(custom.sale_start)が未来の商品は、売り切れではなくCOMING SOONを表示する
    // 発売日未定(custom.coming_soon)で、どのバリエーションにも在庫が無い商品も同じ扱い
    // ※Liquid側(snippets/product-item.liquid)の判定と揃えている
    let labelsHtml = '';
    const saleStartTs = parseInt(product.metafields?.sale_start, 10);
    const comingSoonFlg = product.metafields?.coming_soon === true && !product.available;
    const nonSaleStartFlg = (!isNaN(saleStartTs) && saleStartTs * 1000 > Date.now()) || comingSoonFlg;
    if (nonSaleStartFlg) {
      const comingSoonLabel = (window.languages && window.languages.productLabelComingSoon) || 'COMING SOON';
      labelsHtml += `<span class="ProductItem__Label Heading">${comingSoonLabel}</span>`;
    } else if (!product.available) {
      labelsHtml += '<span class="ProductItem__Label ProductItem__Label--soldOut Heading">売り切れ</span>';
    }
    if (product.tags && (product.tags.includes('label_new') || product.tags.includes('label_new_painting'))) {
      labelsHtml += '<span class="ProductItem__Label ProductItem__Label--featured Heading">NEW</span>';
    }

    // お気に入り判定（いずれかの variant が wishlist に含まれていれば登録済み）
    const hasFavorite = (product.variants || []).some(v => wishlistVariantIdSet.has(String(v.id)));
    const favoriteClass = hasFavorite ? ' remove-favorite' : '';

    // 画像スライド（登録画像の先頭3件。Liquid側 product-item.liquid と揃えている）
    const slideImages = (product.images && product.images.length ? product.images : [product.image])
      .filter(Boolean)
      .slice(0, 3);
    const slidesHtml = slideImages.map((src, i) => `
      <a href="/products/${product.handle}" class="ProductItem__Slide">
        <div class="AspectRatio AspectRatio--square" style="max-width: 300px; --aspect-ratio: 1;">
          <img src="${src}" alt="${product.title}"${i === 0 ? '' : ' loading="lazy"'} class="ProductItem__Image">
        </div>
      </a>
    `).join('');

    const isSlider = slideImages.length > 1;
    const dotsHtml = isSlider
      ? `<div class="ProductItem__SliderDots" data-product-item-slider-dots>${slideImages
          .map((_, i) => `<button type="button" class="ProductItem__SliderDot${i === 0 ? ' is-active' : ''}" data-product-item-slider-dot data-slide-index="${i}" aria-label="${i + 1}"></button>`)
          .join('')}</div>`
      : '';
    const arrowsHtml = isSlider
      ? `<button type="button" class="ProductItem__SliderArrow ProductItem__SliderArrow--prev" data-product-item-slider-prev aria-label="前へ" hidden>
           <svg width="8" height="14" viewBox="0 0 8 14" fill="none" aria-hidden="true"><path d="M7 1L1 7l6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
         </button>
         <button type="button" class="ProductItem__SliderArrow ProductItem__SliderArrow--next" data-product-item-slider-next aria-label="次へ">
           <svg width="8" height="14" viewBox="0 0 8 14" fill="none" aria-hidden="true"><path d="M1 1l6 6-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
         </button>`
      : '';

    return `
      <div class="Carousel__Cell">
        <div class="ProductItem">
          <div class="ProductItem__Wrapper">
            <div class="ProductItem__ImageWrapper${isSlider ? ' ProductItem__ImageWrapper--slider' : ''}">
              <div class="ProductItem__Media">
                <div class="ProductItem__Slider"${isSlider ? ' data-product-item-slider' : ''}>
                  ${slidesHtml}
                </div>
                ${arrowsHtml}
                ${dotsHtml}
              </div>
              ${labelsHtml ? `<div class="ProductItem__LabelList">${labelsHtml}</div>` : ''}
            </div>
            <div class="ProductItem__Info ProductItem__Info--left">
              <div class="ProductItem__TitleRow">
                <h2 class="ProductItem__Title Heading">
                  <a href="/products/${product.handle}">${productTitle}</a>
                </h2>
                <button class="multilikes-collection-btn${favoriteClass}" data-multilikes-collection-button data-product-handle="${product.handle}">
                  <svg class="icon-heart" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
                </button>
              </div>
              <div class="ProductItem__PriceList Heading${priceListClass}">
                ${priceHtml}
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }).join('');

  const html = `
    <section class="Section Section--spacingLarge custom-prod-recently-section c-artist-item-block" data-section-type="recently-viewed-products">
      <header class="SectionHeader SectionHeader--center">
        <div class="Container">
          <h2 class="SectionHeader__Heading Heading u-h1">同じアートの商品</h2>
        </div>
      </header>
      <div class="ProductListWrapper">
        <div class="ProductList ProductList--carousel Carousel">
          ${carouselItems}
        </div>
      </div>
    </section>
  `;
  
  container.innerHTML = html;
}

// DOMContentLoadedでOTHER ARTとArtist Itemを初期化
document.addEventListener('DOMContentLoaded', () => {
  renderOtherArt();
  renderArtistItem();
});
